import React from 'react';
import { Input, DatePicker, Form } from 'antd';
import moment from 'moment';
import AdvancedSearch from '../advanced-search';
import CombineSelect from '../combine-select';

const { RangePicker } = DatePicker;
const { Search } = Input;
const { Item } = Form;

const switchForm = (item, onSearch, functionMap, cb, form) => {
  const {
    type,
    placeholder,
    request,
    requestParams = {},
    antdProps = {},
    name,
    hasDefault,
    days = 30,
    format = 'YYYY-MM-DD HH:mm',
    searchExpand,
  } = item;

  const props = {
    placeholder,
    allowClear: true,
  };

  switch (type) {
    case 'select':
      return (
        <CombineSelect
          antdProps={{ ...antdProps, ...props }}
          onChange={onSearch}
          request={functionMap[request]}
          api={request}
          type="select"
          requestParams={requestParams}
          ifStore="store"
        />
      );
    case 'cascader':
      return (
        <CombineSelect
          antdProps={{ ...antdProps, ...props }}
          onChange={onSearch}
          request={functionMap[request]}
          type="cascader"
          api={request}
        />
      );
    case 'rangepicker':
      // eslint-disable-next-line callback-return
      hasDefault && cb(name, [moment().subtract(days, 'days'), moment().subtract(-1, 'days')]);
      return (
        <RangePicker
          {...props}
          {...antdProps}
          showTime={{
            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')],
          }}
          allowClear={true}
          onChange={onSearch}
          format={format}
        />
      );
    case 'datepicker':
      return <DatePicker {...antdProps} onChange={onSearch} />;
    case 'input':
    default:
      if (searchExpand) {
        return <AdvancedSearch props={props} name={name} form={form} expand={searchExpand} onSearch={onSearch} />;
      }

      return <Search {...props} onSearch={onSearch} />;
  }
};

const uiType = (item, onSearch, functionMap, cb, form) => {
  const { name, rules } = item;
  const itemProps = {
    name,
    rules,
  };

  return <Item {...itemProps}>{switchForm(item, onSearch, functionMap, cb, form)}</Item>;
};

export { uiType };
